const countries = [
    { value: "argentina", label: "Argentina" },
    { value: "brazil", label: "Brazil" },
    { value: "chile", label: "Chile" },
    { value: "colombia", label: "Colombia" },
    { value: "egypt", label: "Egypt" },
    { value: "france", label: "France" },
    { value: "germany", label: "Germany" },
    { value: "india", label: "India" },
    { value: "indonesia", label: "Indonesia" },
    { value: "israel", label: "Israel" },
    { value: "italy", label: "Italy" },
    { value: "malaysia", label: "Malaysia" },
    { value: "mexico", label: "Mexico" },
    { value: "netherlands", label: "Netherlands" },
    { value: "nigeria", label: "Nigeria" },
    { value: "pakistan", label: "Pakistan" },
    { value: "peru", label: "Peru" },
    { value: "russia", label: "Russia" },
    { value: "saudi-arabia", label: "Saudi Arabia" },
    { value: "south-africa", label: "South Africa" },
    { value: "spain", label: "Spain" },
    { value: "turkey", label: "Turkey" },
    { value: "uae", label: "United Arab Emirates" },
    { value: "uk", label: "United Kingdom" },
    { value: "north-america", label: "North America" },
    { value: "rest-of-africa", label: "Rest of Africa" },
    { value: "rest-of-asia-pacific", label: "Rest of Asia Pacific" },
    { value: "rest-of-cee", label: "Rest of Central & Eastern Europe" },
    { value: "rest-of-latin-america", label: "Rest of Latin America" },
    { value: "rest-of-middle-east", label: "Rest of Middle East" },
    { value: "rest-of-western-europe", label: "Rest of Western Europe" },
    { value: "other", label: "Other" },
  ];
  const marketingCosts = {
    USD: {
      argentina: 0.0618,
      brazil: 0.0625,
      chile: 0.0889,
      colombia: 0.0125,
      egypt: 0.1073,
      france: 0.1432,
      germany: 0.1365,
      india: 0.0107,
      indonesia: 0.0411,
      israel: 0.0353,
      italy: 0.0691,
      malaysia: 0.086,
      mexico: 0.0436,
      netherlands: 0.1597,
      nigeria: 0.0516,
      pakistan: 0.0473,
      peru: 0.0703,
      russia: 0.0802,
      "saudi-arabia": 0.0455,
      "south-africa": 0.0379,
      spain: 0.0615,
      turkey: 0.0109,
      uae: 0.0384,
      uk: 0.0529,
      "north-america": 0.025,
      "rest-of-africa": 0.0225,
      "rest-of-asia-pacific": 0.0732,
      "rest-of-cee": 0.086,
      "rest-of-latin-america": 0.074,
      "rest-of-middle-east": 0.0341,
      "rest-of-western-europe": 0.0592,
      other: 0.0604,
    },
    EUR: {
      argentina: 0.0512,
      brazil: 0.0518,
      chile: 0.0736,
      colombia: 0.0104,
      egypt: 0.0889,
      france: 0.1186,
      germany: 0.1131,
      india: 0.0083,
      indonesia: 0.0341,
      israel: 0.0292,
      italy: 0.0572,
      malaysia: 0.0712,
      mexico: 0.0361,
      netherlands: 0.1323,
      nigeria: 0.0428,
      pakistan: 0.0392,
      peru: 0.0582,
      russia: 0.0664,
      "saudi-arabia": 0.0336,
      "south-africa": 0.0314,
      spain: 0.0509,
      turkey: 0.009,
      uae: 0.0282,
      uk: 0.0584,
      "north-america": 0.0207,
      "rest-of-africa": 0.0186,
      "rest-of-asia-pacific": 0.0606,
      "rest-of-cee": 0.0712,
      "rest-of-latin-america": 0.0612,
      "rest-of-middle-east": 0.0282,
      "rest-of-western-europe": 0.049,
      other: 0.05,
    },
  };
  const utilityCosts = {
    USD: {
      argentina: 0.0408,
      brazil: 0.0350,
      chile: 0.0586,
      colombia: 0.0085,
      egypt: 0.0687,
      france: 0.0768,
      germany: 0.0853,
      india: 0.0042,
      indonesia: 0.0200,
      israel: 0.0188,
      italy: 0.0420,
      malaysia: 0.0200,
      mexico: 0.0266,
      netherlands: 0.0800,
      nigeria: 0.0319,
      pakistan: 0.0253,
      peru: 0.0419,
      russia: 0.0477,
      "saudi-arabia": 0.0252,
      "south-africa": 0.0200,
      spain: 0.0380,
      turkey: 0.0093,
      uae: 0.0198,
      uk: 0.0398,
      "north-america": 0.0150,
      "rest-of-africa": 0.0160,
      "rest-of-asia-pacific": 0.0472,
      "rest-of-cee": 0.0619,
      "rest-of-latin-america": 0.0494,
      "rest-of-middle-east": 0.0198,
      "rest-of-western-europe": 0.0420,
      other: 0.0338,
    },
    EUR: {
      argentina: 0.0338,
      brazil: 0.0290,
      chile: 0.0485,
      colombia: 0.0071,
      egypt: 0.0569,
      france: 0.0636,
      germany: 0.0707,
      india: 0.0035,
      indonesia: 0.0166,
      israel: 0.0155,
      italy: 0.0347,
      malaysia: 0.0166,
      mexico: 0.0220,
      netherlands: 0.0663,
      nigeria: 0.0265,
      pakistan: 0.0210,
      peru: 0.0347,
      russia: 0.0395,
      "saudi-arabia": 0.0209,
      "south-africa": 0.0166,
      spain: 0.0315,
      turkey: 0.0077,
      uae: 0.0164,
      uk: 0.0330,
      "north-america": 0.0124,
      "rest-of-africa": 0.0133,
      "rest-of-asia-pacific": 0.0391,
      "rest-of-cee": 0.0512,
      "rest-of-latin-america": 0.0409,
      "rest-of-middle-east":0.0164,
      "rest-of-western-europe": 0.0348,
      other: 0.0280,
    },
  };
  const authenticationCosts = {
    USD: {
      argentina: 0.0367,
      brazil: 0.0315,
      chile: 0.0527,
      colombia: 0.0077,
      egypt: 0.0618,
      france: 0.0691,
      germany: 0.0768,
      india: 0.0014,
      indonesia: 0.0300,
      israel: 0.0169,
      italy: 0.0378,
      malaysia: 0.0180,
      mexico: 0.0239,
      netherlands: 0.0720,
      nigeria: 0.0287,
      pakistan: 0.0228,
      peru: 0.0377,
      russia: 0.0429,
      "saudi-arabia": 0.0226,
      "south-africa": 0.0180,
      spain: 0.0342,
      turkey: 0.0083,
      uae: 0.0178,
      uk: 0.0358,
      "north-america": 0.0135,
      "rest-of-africa": 0.0144,
      "rest-of-asia-pacific": 0.0425,
      "rest-of-cee": 0.0557,
      "rest-of-latin-america": 0.0445,
      "rest-of-middle-east":0.0178,
      "rest-of-western-europe": 0.0378,
      other: 0.0304,
    },
    EUR: {
      argentina: 0.0304,
      brazil: 0.0261,
      chile: 0.0437,
      colombia: 0.0063,
      egypt: 0.0512,
      france: 0.0572,
      germany: 0.0636,
      india: 0.0012,
      indonesia: 0.0249,
      israel: 0.0140,
      italy: 0.0313,
      malaysia: 0.0149,
      mexico: 0.0198,
      netherlands: 0.0596,
      nigeria: 0.0238,
      pakistan: 0.0189,
      peru: 0.0312,
      russia: 0.0355,
      "saudi-arabia": 0.0187,
      "south-africa": 0.0149,
      spain: 0.0283,
      turkey: 0.0069,
      uae: 0.0147,
      uk: 0.0297,
      "north-america": 0.0112,
      "rest-of-africa": 0.0119,
      "rest-of-asia-pacific": 0.0352,
      "rest-of-cee": 0.0461,
      "rest-of-latin-america": 0.0368,
      "rest-of-middle-east":0.0147,
      "rest-of-western-europe": 0.0313,
      other: 0.0252,
    },
  };
  const serviceCosts = {
    USD: {
      argentina: 0.0316,
      brazil: 0.0300,
      chile: 0.0454,
      colombia: 0.0060,
      egypt: 0.0644,
      france: 0.0859,
      germany: 0.0819,
      india: 0.0040,
      indonesia: 0.0190,
      israel: 0.0180,
      italy: 0.0386,
      malaysia: 0.0220,
      mexico: 0.0105,
      netherlands: 0.0891,
      nigeria: 0.0310,
      pakistan: 0.0142,
      peru: 0.0179,
      russia: 0.0398,
      "saudi-arabia": 0.0195,
      "south-africa": 0.0168,
      spain: 0.0369,
      turkey: 0.0030,
      uae: 0.0190,
      uk: 0.0388,
      "north-america": 0.0088,
      "rest-of-africa": 0.0363,
      "rest-of-asia-pacific": 0.0224, 
      "rest-of-cee": 0.0250,
      "rest-of-latin-america": 0.0423,
      "rest-of-middle-east": 0.0218,
      "rest-of-western-europe": 0.0397,
      other: 0.0145,
    },
    EUR: {
      argentina: 0.0261,
      brazil: 0.0248,
      chile: 0.0376,
      colombia: 0.0050,
      egypt: 0.0533,
      france: 0.0712,
      germany: 0.0679,
      india: 0.0033,
      indonesia: 0.0157,
      israel: 0.0149,
      italy: 0.0319,
      malaysia: 0.0182,
      mexico: 0.0087,
      netherlands: 0.0738,
      nigeria: 0.0257,
      pakistan: 0.0118,
      peru: 0.0149,
      russia: 0.0329,
      "saudi-arabia": 0.0161,
      "south-africa": 0.0139,
      spain: 0.0305,
      turkey: 0.0025,
      uae: 0.0157,
      uk: 0.0321,
      "north-america": 0.0073,
      "rest-of-africa": 0.0300,
      "rest-of-asia-pacific": 0.0185, 
      "rest-of-cee": 0.0207,
      "rest-of-latin-america": 0.0351,
      "rest-of-middle-east": 0.0181,
      "rest-of-western-europe": 0.0329,
      other: 0.0120,
    },
  };
  export {countries , marketingCosts, utilityCosts , authenticationCosts , serviceCosts};